// extracted by css-extract-rspack-plugin
export default {"button":"_1ba6181f"};